import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'
import { dateConstants } from '@/modules/base/util/constants'
import { cloneDeep } from 'lodash'

export const handleAddToCartForGtm = (cartItem, count, type, itemsCount) => {
  const itemName = cartItem.name
  const updatedItemsCount = cloneDeep(itemsCount)
  if (!updatedItemsCount[type]) {
    updatedItemsCount[type] = {}
  }
  if (!updatedItemsCount[type][itemName]) {
    updatedItemsCount[type][itemName] = {}
  }

  const previousCount = updatedItemsCount[type][itemName]?.count || 0
  const quantityChange = Math.abs(count - previousCount)
  updatedItemsCount[type][itemName].count = count

  const action = count > previousCount ? GtmEventTypes.AddToCart : GtmEventTypes.RemoveFromCart
  const period = cartItem.paymentIntervalOfSubscription || cartItem.period
  const priceObj = cartItem.prices.find(price => price.period === period)?.values?.[0]
  const price = priceObj?.pricePerDuration || 0
  const item = {
    item_name: `${cartItem.name} ${type} ${period}`,
    index: 0,
    item_brand: 'orgamax',
    item_category: `orgamax [${type}]`,
    price,
    quantity: quantityChange,
  }

  GtmService.pushEvent({
    'event': action,
    ecommerce: {
      currency: 'EUR',
      value: price * quantityChange,
      items: [item],
    },
  })
}

export const handleDeleteForGtm = (type, cartItem) => {
  const period = cartItem.paymentIntervalOfSubscription || cartItem.period
  const priceObj = cartItem.prices.find(price => price.period === period)?.values?.[0]
  const price = priceObj?.pricePerDuration || 0
  const item = {
    item_name: `${cartItem.name} ${type} ${period}`,
    index: 0,
    item_brand: 'orgamax',
    item_category: `orgamax [${type}]`,
    price,
    quantity: cartItem.count,
  }

  GtmService.pushEvent({
    event: GtmEventTypes.RemoveFromCart,
    ecommerce: {
      currency: 'EUR',
      value: price * cartItem.count,
      items: [item],
      removeCompleteItem: true,
    },
  })
}

export const handlePurchaseForGtm = (cartItems) => {
  let totalPrice = 0
  const items = []

  cartItems.forEach((cartItem, index) => {
    totalPrice += cartItem.pricePerDuration * cartItem.count
    const item = {
      item_name: `${cartItem.name} ${cartItem.type}`,
      index,
      item_brand: 'orgamax',
      item_category: `orgamax [${cartItem.type}]`,
      price: cartItem.pricePerDuration,
      quantity: cartItem.count,
    }
    items.push(item)
  })

  GtmService.pushEvent({
    'event': GtmEventTypes.Purchase,
    ecommerce: {
      currency: 'EUR',
      value: totalPrice,
      items,
    },
  })
}

export const handleConfirmCheckoutForGtm = (cartItems, period?) => {
  let totalPrice = 0
  const items = []
  Object.entries(cartItems).forEach(([parentName, parentItem]) => {
    Object.entries(parentItem).forEach(([itemName, cartItem], index) => {
      const priceObj = cartItem.prices.find(price => price.period === dateConstants.YEAR)?.values?.[0]
      const price = priceObj?.pricePerDuration || 0
      totalPrice += price * cartItem.count
      const item = {
        item_name: `${cartItem.name} ${parentName} ${period}`,
        index,
        item_brand: 'orgamax',
        item_category: `orgamax [${itemName}]`,
        price,
        quantity: cartItem.count,
      }
      items.push(item)
    })
  })
  GtmService.pushEvent({
    'event': GtmEventTypes.BeginCheckout,
    ecommerce: {
      currency: 'EUR',
      value: totalPrice,
      items,
    },
  })
}
